import { downloadPromotionsInXlsx } from "../../api";
import { toast } from "react-toastify";
import { saveFileResponse } from "../../utils/fileDownload";

const buildExportQueryString = ({ queryParams, propertyId }) => {
  const params = new URLSearchParams();
  params.append("propertyId", propertyId);
  if (queryParams.status) params.append("status", queryParams.status);
  if (queryParams.promoType) params.append("promoType", queryParams.promoType);
  if (queryParams.search && queryParams.search.length >= 3) {
    params.append("search", queryParams.search);
  }
  return `?${params.toString()}`;
};

export const exportPromotions = async ({ queryParams, propertyId }) => {
  const queryString = buildExportQueryString({ queryParams, propertyId });
  try {
    const response = await downloadPromotionsInXlsx(queryString);
    saveFileResponse(response, "promotions.xlsx");
    toast.success("Export successful");
  } catch {
    toast.error("Export failed");
  }
};
